export const SCREEN_TYPE = {
  mytiaa: 'auth',
  public: 'nonAuth',
  microsites: 'auth', //not sure
  slam: 'nonAuth', //not sure
  plan: 'auth'
};

export const SCREENS = {
  auth: 329,
  nonAuth: 296
};

export const getScreenerType = (type, isPlan = false) => {
  return isPlan ? SCREENS[SCREEN_TYPE.plan] : SCREENS[SCREEN_TYPE[type]];
};

export default getScreenerType;
